<bw-modal-legacy *ngIf="visible" (closeModal)="dismissClick()">
  <typography-legacy title-medium>Welcome to Brightside</typography-legacy>
  <div class="body">You haven’t created a Brightside account yet. Let’s get started with registration!</div>
  <div class="footer flex-row row-reverse">
    <button bw-button-legacy (click)="ctaClick()">Sign Up</button>
    <a bw-anchor-legacy (click)="dismissClick()" style="margin: 0 16px;">Cancel</a>
  </div>
</bw-modal-legacy>
